import {
  STYTCH_ACTIVE_SESSION_DURATION,
  STYTCH_MAX_SESSION_DURATION_MINUTES,
} from '@/utilities/stytch/sessionDurationMinutes'

export const PATIENT_PORTAL_SESSION_MIN_MINUTES = 5
export const PATIENT_PORTAL_SESSION_MAX_MINUTES = STYTCH_MAX_SESSION_DURATION_MINUTES
export const PATIENT_PORTAL_SESSION_DEFAULT_MINUTES = STYTCH_ACTIVE_SESSION_DURATION

export const resolvePatientPortalSessionDurationMinutes = (
  value: number | null | undefined,
): number => {
  if (typeof value !== 'number' || !Number.isInteger(value)) {
    return PATIENT_PORTAL_SESSION_DEFAULT_MINUTES
  }

  if (value < PATIENT_PORTAL_SESSION_MIN_MINUTES || value > PATIENT_PORTAL_SESSION_MAX_MINUTES) {
    return PATIENT_PORTAL_SESSION_DEFAULT_MINUTES
  }

  return value
}
